import { CalculateOfferResponse } from '../../shared/interfaces/calculate-offer-response.interface';
import { CreationLockResponse } from '../../shared/interfaces/creation-lock-response.interface';
import { PolicyCreatorStateModel } from './policy-creator.model';

export interface OfferStateModel {
  offer: CalculateOfferResponse;
  offerLocked: CreationLockResponse;
  isLoading: boolean;
}

export const defaults: OfferStateModel = {
  offer: null,
  offerLocked: null,
  isLoading: true,
};

export interface OfferStateSnapshot {
  policyCreatorState: PolicyCreatorStateModel;
  offer: CalculateOfferResponse;
  offerLocked: CreationLockResponse;
}
